import React from 'react';
import { connect } from 'react-redux';
import { notificationSelector } from './selectors';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import {
  faInfoCircle,
  faTimesCircle,
  faExclamationTriangle,
  faCheckCircle,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const REDUX_NOTIFICATION_TYPES = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
};
class Notification extends React.Component {
  timeOutRef = null;

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.hideNotification(this.props);
    }
  }

  hideNotification = (props) => {
    if (props.notification.show) {
      this.timeOutRef = setTimeout(() => {
        this.props.hideNotification(props.notification.message, props.notification.timeout, props.notification.type);
      }, props.notification.timeout * 1000);
    }
  };

  onClose = () => {
    clearTimeout(this.timeOutRef);
    this.props.hideNotification(
      this.props.notification.message,
      this.props.notification.timeout,
      this.props.notification.type
    );
  };

  render() {
    const { show, type, message } = this.props.notification;

    return (
      <div className={`ct-notification ${!show ? `ct-notification--hide` : ''}`}>
        <div
          className={`ct-notification__wrapper ct-notification__wrapper--${type} `}
          data-e2e={`ct-notification-${type}`}
        >
          <div className="ct-notification__wrapper__icon">
            {type === REDUX_NOTIFICATION_TYPES.INFO && (
              <FontAwesomeIcon icon={faInfoCircle} className="ct-notification__icon" />
            )}

            {type === REDUX_NOTIFICATION_TYPES.ERROR && (
              <FontAwesomeIcon icon={faTimesCircle} className="ct-notification__icon" />
            )}

            {type === REDUX_NOTIFICATION_TYPES.WARNING && (
              <FontAwesomeIcon icon={faExclamationTriangle} className="ct-notification__icon" />
            )}

            {type === REDUX_NOTIFICATION_TYPES.SUCCESS && (
              <FontAwesomeIcon icon={faCheckCircle} className="ct-notification__icon" />
            )}
          </div>

          <div className="ct-notification__wrapper__body">{message}</div>

          <div className="ct-notification__wrapper__close" onClick={this.onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
        </div>
      </div>
    );
  }
}

export const ReduxNotification = connect(
  (state) => ({
    notification: notificationSelector(state),
  }),
  (dispatch) => ({
    hideNotification: (message, timeout, type) => dispatch(reduxNotificationAction(message, false, timeout, type)),
  })
)(Notification);

export * from './actions';
export * from './selectors';
